export const getPercentFormatter = (options: Record<string, any> = {}) => {
  const formatter = new Intl.NumberFormat(undefined, {
    ...options,
    style: 'percent'
  })
  return {
    format: (value: number) => {
      const { showLessThan1Percent } = options
      if (showLessThan1Percent !== false) {
        return value < 0.01 ? '< 1%' : formatter.format(value)
      }
      return formatter.format(value)
    }
  }
}
export const getNumberFormatter = () =>
  new Intl.NumberFormat(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3
  })
